import {
  DocumentReference,
  isDocRef,
  TypeGuard,
} from '@principle-theorem/shared';
import { isString } from 'lodash';
import { ITreatmentStep } from '../../../clinical-charting/treatment/treatment-step';
import { IMohHighCariesData } from '../../moh/high-caries';
import { MohClaimType } from '../../moh/moh';
import { IFundingRequest } from '../funding-request';
import { IMohClaimFundingRequest } from './moh-claim';

export enum MohPreApprovalAttachment {
  PreApproval = 'preApproval',
  HighCaries = 'highCaries',
  Signature = 'signature',
}

export type MohHighCariesProviderData = Pick<
  IMohHighCariesData,
  | 'requestReason'
  | 'dentinalToothStructure'
  | 'teethBeenFissureSealed'
  | 'teethRestored'
  | 'notFissureSealedReason'
  | 'dateFissureSealed'
  | 'dateTeethRestored'
  | 'otherComments'
>;

export interface IMohPreApprovalFundingRequestData {
  stepRef: DocumentReference<ITreatmentStep>;
  claimType: MohClaimType;
  approvalNumber?: string;
  mohClaimRef?: DocumentReference<IMohClaimFundingRequest>;
  preApprovalFormPath?: string;
  highCariesFormPath?: string;
  signaturePath?: string;
}

export type IMohPreApprovalFundingRequest =
  IFundingRequest<IMohPreApprovalFundingRequestData>;

export const isMohPreApprovalFundingRequestData =
  TypeGuard.interface<IMohPreApprovalFundingRequestData>({
    claimType: TypeGuard.enumValue(MohClaimType),
    stepRef: isDocRef,
    approvalNumber: TypeGuard.nilOr(isString),
    mohClaimRef: TypeGuard.undefinedOr(isDocRef),
    preApprovalFormPath: TypeGuard.undefinedOr(isString),
    highCariesFormPath: TypeGuard.undefinedOr(isString),
    signaturePath: TypeGuard.undefinedOr(isString),
  });
